(() => {
  const section = document.querySelector('[data-bcos-gifting]');
  if (!section) return;

  const wrapCheck = section.querySelector('[data-gift-wrap]');
  const wrapTotalEl = section.querySelector('[data-gift-wrap-total]');
  const summaryTotalEl = section.querySelector('[data-gift-summary-total]');
  const summaryList = section.querySelector('[data-gift-summary]');
  const messageInput = section.querySelector('[data-gift-message]');
  const messageCounter = section.querySelector('[data-gift-message-counter]');
  const receiptCheck = section.querySelector('[data-gift-receipt]');
  const occasionSelect = section.querySelector('[data-gift-occasion]');
  const deliveryInput = section.querySelector('[data-gift-delivery]');

  const wrapPrice = parseInt(wrapCheck?.dataset.giftWrapPrice || '0', 10);
  const wrapVariantId = wrapCheck?.dataset.giftWrapVariant || '';
  const wrapTitle = wrapCheck?.dataset.giftWrapTitle || '';
  const messageMax = parseInt(messageInput?.maxLength || '250', 10);

  function track(name, data) {
    if (window.BcosAnalytics && typeof window.BcosAnalytics.track === 'function') {
      window.BcosAnalytics.track(name, data || {}, 'analytics');
    }
  }

  function formatMoney(cents) {
    return window.Shopify?.formatMoney
      ? window.Shopify.formatMoney(cents, window.Shopify.moneyFormat)
      : new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: window.Shopify?.currency?.active || 'USD',
        }).format(cents / 100);
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getState() {
    return {
      wrap: !!wrapCheck?.checked,
      message: (messageInput?.value || '').trim(),
      receipt: !!receiptCheck?.checked,
      occasion: occasionSelect?.value || '',
      delivery: deliveryInput?.value || '',
    };
  }

  function updateSummary() {
    const state = getState();
    const wrapTotal = state.wrap ? wrapPrice : 0;
    if (wrapTotalEl) wrapTotalEl.textContent = formatMoney(wrapTotal);
    if (summaryTotalEl) summaryTotalEl.textContent = formatMoney(wrapTotal);

    if (summaryList) {
      const entries = [];
      if (state.wrap) entries.push(`Gift wrapping: ${wrapTitle}`);
      if (state.message) entries.push('Personal message');
      if (state.receipt) entries.push('Gift receipt');
      if (state.occasion) entries.push(`Occasion: ${state.occasion}`);
      if (state.delivery) entries.push(`Deliver on ${state.delivery}`);
      summaryList.innerHTML = entries.length
        ? entries.map((entry) => `<li>${escapeHtml(entry)}</li>`).join('')
        : '<li class="bcos-gifting__summary-empty">No gift options selected</li>';
    }
  }

  function updateCounter() {
    if (!messageInput || !messageCounter) return;
    const length = messageInput.value.length;
    messageCounter.textContent = `${length} / ${messageMax}`;
    messageCounter.classList.toggle('bcos-gifting__counter--limit', length >= messageMax);
  }

  if (deliveryInput) {
    const today = new Date();
    const offset = today.getTimezoneOffset();
    const local = new Date(today.getTime() - offset * 60 * 1000);
    deliveryInput.min = local.toISOString().slice(0, 10);
  }

  const optionEls = [wrapCheck, receiptCheck, messageInput, occasionSelect, deliveryInput].filter(Boolean);
  optionEls.forEach((el) => {
    el.addEventListener(el.type === 'checkbox' ? 'change' : 'input', () => {
      updateSummary();
      updateCounter();
    });
  });

  if (wrapCheck) {
    wrapCheck.addEventListener('change', () => {
      updateSummary();
      track(wrapCheck.checked ? 'gift_wrap_selected' : 'gift_wrap_removed', {
        variant_id: wrapVariantId,
        price: wrapPrice / 100,
      });
    });
  }

  if (messageInput) {
    messageInput.addEventListener('input', () => {
      updateSummary();
      updateCounter();
    });
    messageInput.addEventListener('change', () => {
      if (messageInput.value.trim()) track('gift_message_added');
    });
  }

  if (receiptCheck) {
    receiptCheck.addEventListener('change', () => {
      updateSummary();
      if (receiptCheck.checked) track('gift_receipt_selected');
    });
  }

  if (deliveryInput) {
    deliveryInput.addEventListener('change', () => {
      updateSummary();
      if (deliveryInput.value) track('gift_delivery_scheduled', { date: deliveryInput.value });
    });
  }

  const giftSubmitBtn = section.querySelector('[data-gift-add-to-cart]');
  giftSubmitBtn?.addEventListener('click', () => {
    const form = document.querySelector('[data-bcos-add-to-cart]');
    if (!form) return;
    const state = getState();
    if (!state.wrap && !state.message && !state.receipt && !state.occasion && !state.delivery) {
      track('gift_add_to_cart_clicked', { options: 0 });
    }
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.submit();
    }
  });

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target.closest('[data-bcos-add-to-cart]');
      if (!form) return;
      const state = getState();
      if (!state.wrap && !state.message && !state.receipt && !state.occasion && !state.delivery) return;

      if (state.wrap && wrapVariantId) {
        const extra = document.createElement('input');
        extra.type = 'hidden';
        extra.name = 'items[][id]';
        extra.value = wrapVariantId;
        extra.dataset.bcosExtraItem = 'true';
        form.appendChild(extra);

        const qty = document.createElement('input');
        qty.type = 'hidden';
        qty.name = 'items[][quantity]';
        qty.value = '1';
        form.appendChild(qty);
      }

      const props = {
        'Gift wrap': state.wrap ? 'Yes' : '',
        'Gift message': state.message,
        'Gift receipt': state.receipt ? 'Yes' : '',
        'Gift occasion': state.occasion,
        'Delivery date': state.delivery,
      };
      Object.keys(props).forEach((key) => {
        const value = props[key];
        if (!value) return;
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = `properties[${key}]`;
        input.value = value;
        form.appendChild(input);
      });
    },
    true
  );

  updateSummary();
  updateCounter();
})();
